export default __webpack_public_path__ + "static/media/code_of_life_konfety.59b6feea.jpg";